define('viewmodels/configuration/OrganizationalLevels',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings'],
    function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings) {
        var OLViewModel = {
            activate: activate,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            OpenOrganizationalLevelPopup: OpenOrganizationalLevelPopup,
            ControlsAccess: ko.observable(false),
            setTriggerAttach: true,
            BusinessLevelList: ko.observableArray(),
            BusinessLevelValueList: ko.observableArray(),
            SelectedBusinessLevelDetails: ko.observableArray(),
            editableBusinessLevel: ko.observable(),
            saveOrgLevelPopUpButton: saveOrgLevelPopUpButton,
            editFunctionalityOL: editFunctionalityOL,
            deleteFunctionalityOL: deleteFunctionalityOL,
            OpenOrganizationalLowestlevelpopup: OpenOrganizationalLowestlevelpopup,
            CancelOrgLowestLevelPopUpButton: CancelOrgLowestLevelPopUpButton,
            addPopUpCss: ko.observable(true),
            editPopUpCss: ko.observable(true),
            popUpTitle: ko.observable(),
            LowestLevelName: ko.observable(),
            LowestLevelNameDup: ko.observableArray(),
            saveOrgLowestLevelPopUpButton: saveOrgLowestLevelPopUpButton,
            trclick: trclick,
            addBusinessLevelValueFunctionality: addBusinessLevelValueFunctionality,
            editableBusinessLevelValue: ko.observable(),
            BlId: ko.observable(),
            saveRsfButton: saveRsfButton,
            cancelRsfButton: cancelRsfButton,
            rsfPopUpTitle: ko.observable(),
            BlvalueName: ko.observable(),
            BlvalueShortName: ko.observable(),
            editOLValueFunctionality: editOLValueFunctionality,
            deleteOLValueFunctionality: deleteOLValueFunctionality,
            BlvalueId: ko.observable(),
            currentTarget: ko.observable(),
            CurrentScreenName: ko.observable(),
            LocaleCheckFlag: ko.observable(false),

        };
        return OLViewModel;
        var isEdit;
        function activate() {
            try {
                $('#adddivtab').on('click', function () {
                });

                if (OLViewModel.ObjGeneralSettings === undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((OLViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && OLViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    OLViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (OLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() == null || OLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || OLViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || OLViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            OLViewModel.LocaleCheckFlag(false);
                        else
                            OLViewModel.LocaleCheckFlag(true);
                    });
                } else
                    OLViewModel.LocaleCheckFlag(true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        };

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            OLViewModel.ControlsAccess(true);
                        }
                        else {
                            OLViewModel.ControlsAccess(false);
                        }
                    });
                }
                else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                    OLViewModel.ControlsAccess(true);
                }
                else {
                    OLViewModel.ControlsAccess(false);
                }
                var url = window.location.hash;
                OLViewModel.CurrentScreenName = url.substring(url.lastIndexOf('/') + 1);
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
                $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
                GetLowestOrganizationalName().then(function () {
                    GetAllBusinessLevels();
                })

                if (OLViewModel.ObjGeneralSettings === undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((OLViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && OLViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    OLViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (OLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() == null || OLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || OLViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || OLViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            OLViewModel.LocaleCheckFlag(false);
                        else
                            OLViewModel.LocaleCheckFlag(true);
                    });
                } else
                    OLViewModel.LocaleCheckFlag(true);


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        /*****************************************FOR ORGANIZATIONAL LEVELS*****************************************************/
        function OpenOrganizationalLowestlevelpopup() {
            try {
                OLViewModel.popUpTitle((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UpdateLowestOrgDetails') == -1) ? 'Update Lowest Organizational Level Details' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UpdateLowestOrgDetails')].Name());
                OLViewModel.addPopUpCss(true);
                $('#frmLowestLevel').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
                setTimeout("$('#FirstInput').focus();", 200);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenOrganizationalLowestlevelpopup() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function OpenOrganizationalLevelPopup() {
            try {


                var newBusinessLevel = new BusinessLevelModel({ BlId: 999, BlName: "", BlDescription: "", BlShortName: "" });
                OLViewModel.editableBusinessLevel(newBusinessLevel);
                OLViewModel.popUpTitle((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddLowestOrgDetails') == -1) ? 'Add Organizational Level Details' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddLowestOrgDetails')].Name());
                OLViewModel.addPopUpCss(true);
                $('#frmOrgLevels').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
                isEdit = false;
                setTimeout("$('#FirstInputpopup').focus();", 200);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenOrganizationalLevelPopup() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function saveOrgLevelPopUpButton(data) {
            try {
                $('#valError').hide();
                var duplicateCheck = 0;
                for (var i = 0, j = OLViewModel.BusinessLevelList().length; i < j; i++) {
                    if ((data.BlName().toUpperCase() == OLViewModel.BusinessLevelList()[i].BlName().toUpperCase()) && (data.TargetRow() != i))
                        duplicateCheck++;
                }
                if (data.BlName() == "") {
                    $('#valError').show();
                    $('#valError').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelNameRequired') == -1) ? 'Organizational Level Name is required.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelNameRequired')].Name());
                }
                else if (data.BlShortName() == "") {
                    $('#valError').show();
                    $('#valError').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelShrtNameRequired') == -1) ? 'Organizational Level Short Name is required.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelShrtNameRequired')].Name());
                }
                else
                    if (data.BlShortName().length > 25) {
                        $('#valError').show();
                        $('#valError').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelShrtName25chars') == -1) ? 'Organizational Level Short Name cannot exceed 25 characters.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelShrtName25chars')].Name());
                    }
                    else if (data.BlName().length > 300) {
                        $('#valError').show();
                        $('#valError').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelName100chars') == -1) ? 'Organizational Level Name cannot exceed 100 characters.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelName100chars')].Name());
                    }
                    else {
                        if (!isEdit) {
                            if (duplicateCheck == 1) {
                                $('#valError').text('"'+ data.BlName() +'"' +' ' + ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsOrgLevel') == -1) ? 'already exists. Please enter a different Organizational Level.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsOrgLevel')].Name())) ;
                                $('#valError').show();

                            }
                            else {

                                addOrganizationalLevel(data);
                                $('#frmOrgLevels').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }
                        }
                        else {
                            if (duplicateCheck == 1) {
                                $('#valError').show();
                                $('#valError').text(data.BlName() + ' ' + (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsOrgLevel') == -1) ? 'already exists. Please enter a different Organizational Level.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsOrgLevel')].Name());
                            }
                            else {
                                updateOrganizationalLevel(data);
                                $('#frmOrgLevels').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }
                        }
                    }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveOrgLevelPopUpButton() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        //Adds the Business Levels
        function addOrganizationalLevel(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/AddOrganizationalLevel",
                    headers: headers,
                    type: "POST",
                    data: { BlName: data.BlName(), BlShortName: data.BlShortName(), BlDescription: data.BlDescription() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in addOrganizationalLevel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.BlId != 0 && jsonResult.BlName != null) {
                            if (jsonResult.Flag == 1) {
                                //   $("#tblOrgLevels").load();
                                GetAllBusinessLevels();
                                logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelAdded') == -1) ? 'Organizational Level has been added successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelAdded')].Name(), 'Success', system.getModuleId(OLViewModel), true);
                            }
                        }
                        else {
                            var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelAddFailed') == -1) ? 'Failed to add the Organizational Level.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelAddFailed')].Name();
                            logger.logError(jsonResult.SurveyStatus + " - " + msg, 'Error', system.getModuleId(OLViewModel), true);
                        }
                    }
                    else {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(jsonResult.SurveyStatus + " - " + msg, 'Error', system.getModuleId(OLViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
                $('#frmOrgLevels').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addOrganizationalLevel() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in addOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
        }

        //editing Business Levels
        function editFunctionalityOL(data, event) {
            try {
                var row = $(event.currentTarget).closest('tr').get(0);
                data.TargetRow(row._DT_RowIndex);
                var newBusinessLevel = new BusinessLevelModel({ BlId: data.BlId(), BlName: data.BlName(), BlDescription: data.BlDescription(), BlShortName: data.BlShortName() });
                newBusinessLevel.TargetRow(row._DT_RowIndex);
                OLViewModel.editableBusinessLevel(newBusinessLevel);
                OLViewModel.popUpTitle((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOrgLeveldetails') == -1) ? 'Edit Organizational Level Details' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOrgLeveldetails')].Name());
                OLViewModel.addPopUpCss(false);
                OLViewModel.editPopUpCss(true);
                $('#frmOrgLevels').modal('show');
                $('#modalContentFactor').css({
                    'margin-top': '30%'
                });
                isEdit = true;
                setTimeout("$('#FirstInputpopup').focus();", 200);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function updateOrganizationalLevel(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/updateOrganizationalLevel",
                    headers: headers,
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify({ BlId: data.BlId(), BlName: data.BlName(), BlShortName: data.BlShortName(), BlDescription: data.BlDescription() })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in updateOrganizationalLevel() method in OrganizationalLevel.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    var code = result.slice(0, 1);
                    var inc = result.slice(1, 11);
                    if (result == 1) {
                        var rowIndex = data.TargetRow();
                        OLViewModel.BusinessLevelList()[rowIndex].BlId(data.BlId());
                        OLViewModel.BusinessLevelList()[rowIndex].BlName(data.BlName());
                        OLViewModel.BusinessLevelList()[rowIndex].BlShortName(data.BlShortName());
                        OLViewModel.BusinessLevelList()[rowIndex].BlDescription(data.BlDescription());
                        var node = OLTableObj.row(rowIndex).data(['<div style="display:none"></div>', data.BlId(), data.BlName(), data.BlShortName(), data.BlDescription(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button text-center" data-bind="click: $root.editFunctionalityOL"><i class="demo-icon icon-file_edit_special text-success"></i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteFunctionalityOL"><i class="demo-icon icon-bin_special text-danger"></i></a>']).draw(false);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: OLViewModel.editFunctionalityOL }, data);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: OLViewModel.deleteFunctionalityOL }, data);
                        ko.applyBindingsToNode($(node.node()).find('td').get(0), {}, OLViewModel);
                        logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelUpdatedsuc') == -1) ? 'Organizational Level updated successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelUpdatedsuc')].Name(), 'Success', system.getModuleId(OLViewModel), true);

                    }
                    else if (code == 0) {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('noSuchOrglevelmsg') == -1) ? 'No such Organizational Level exists. Please refresh the page and perform the edit operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('noSuchOrglevelmsg')].Name();
                        logger.logWarning(inc + " - " + msg, 'Warning', system.getModuleId(OLViewModel), true);
                    }
                    else {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(result + " - " + msg, 'Error', system.getModuleId(OLViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateOrganizationalLevel() method in OrganizationalLevel.js';
                    logger.logMessage(msg);
                }
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in updateOrganizationalLevel() method in OrganizationalLevel.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in updateOrganizationalLevel() method in OrganizationalLevel.js';
                    logger.logMessage(msg);
                }
            }
        }


        //Deletes Business Levels
        function deleteFunctionalityOL(data, event) {
            try {
                app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg') == -1) ? 'Are you sure you want to delete this Organizational Level? Once deleted, it cannot be undone.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg')].Name(), (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            deleteOrganizationalLevel(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:deleteFunctionalityOL() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function deleteOrganizationalLevel(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/deleteOrganizationalLevel",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        BlID: data.BlId()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    var code = result.slice(0, 1);
                    var inc = result.slice(1, 11);
                    if (result == 1) {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        OLTableObj.row(targetRow).remove().draw(false);
                        OLViewModel.BusinessLevelList.splice(data.TargetRow(), 1);
                        GetAllBusinessLevels();
                        logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelDeleted') == -1) ? 'Organizational Level deleted successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelDeleted')].Name(), 'Success', system.getModuleId(OLViewModel), true);
                    }
                    else if (code == 0) {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchOrgToDelete') == -1) ? 'No such Organizational Level exists. Please refresh the page again and perform the delete operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchOrgToDelete')].Name();
                        logger.logWarning(inc + " - " + msg, 'Warning', system.getModuleId(OLViewModel), true);
                    }
                    else if (code == 2) {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('deleteDependencies') == -1) ? 'The Level that you are trying to delete has dependencies. Please contact the Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('deleteDependencies')].Name();
                        logger.logWarning(inc + " - " + msg, 'Success', system.getModuleId(OLViewModel), true);
                    }
                    else {
                        var msg = (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(result + " - " + msg, 'Error', system.getModuleId(OLViewModel), true);

                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

        }
        function saveOrgLowestLevelPopUpButton() {
            $('#valErrorLowestLevel').hide();

            if (OLViewModel.LowestLevelName() == "") {
                $('#valErrorLowestLevel').show();
                $('#valErrorLowestLevel').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq') == -1) ? 'Name is required.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq')].Name());
            }
            else if (OLViewModel.LowestLevelName().length > 100) {
                $('#valErrorLowestLevel').show();
                $('#valErrorLowestLevel').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('name100chars') == -1) ? 'Entry name cannot exceed 100 characters. Please enter a valid one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('name100chars')].Name());
            }
            else {

                saveOrgLowestLevel();
                $('#frmSubFactor').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();

            }

        }
        function saveOrgLowestLevel() {
            try {
                return true;


                var BuId = 0;
                if (OLViewModel.ObjGeneralSettings == undefined || OLViewModel.ObjGeneralSettings == null || OLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || OLViewModel.ObjGeneralSettings.LocalizedTextList() == null || OLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0) {
                    OLViewModel.ObjGeneralSettings.GetLocalizedData();
                }

                for (var i = 0; i < OLViewModel.ObjGeneralSettings.LocalizedTextList().length; i++) {
                    if (OLViewModel.ObjGeneralSettings.LocalizedTextList()[i].Identifier == 'BusinessUnits') {
                        BuId = OLViewModel.ObjGeneralSettings.LocalizedTextList()[i].NameId;
                        break;
                    }
                }


                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SaveEditedNameDetails",
                    type: "POST",
                    headers: headers,
                    data: { Name: OLViewModel.LowestLevelName(), Identifier: 'BusinessUnits', NameId: BuId }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in saveOrgLowestLevelPopUpButton() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result == 1) {
                        $('#frmLowestLevel').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LowestOrgUpdated') == -1) ? 'Lowest Organizational Unit Name updated successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LowestOrgUpdated')].Name(), 'Success', system.getModuleId(OLViewModel), true);
                        GetLowestOrganizationalName();

                    }
                    else {
                        logger.logmessage('Lowest Organizational Unit Name updation Failed.', 'Success', system.getModuleId(OLViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetLowestOrganizationalName() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
        }
        function CancelOrgLowestLevelPopUpButton(data) {
            try {
                var result = OLViewModel.LowestLevelNameDup();
                OLViewModel.LowestLevelName(result[0].BlName());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in CancelOrgLowestLevelPopUpButton() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }
        //Gets the Business Levels
        function GetAllBusinessLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getAllDistinctBusinessLevels",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllBusinessLevels() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            return new BusinessLevelModel(result);
                        });
                        OLViewModel.BusinessLevelList(MappedBUModelList);
                        for (var i = 0, j = OLViewModel.BusinessLevelList().length; i < j; i++) {
                            GetFactorTabData(OLViewModel.BusinessLevelList()[i]);
                        }
                        OLTableObj = $('#tblOrgLevels').DataTable();
                        OLTableObj.destroy();
                        $("#tblOrgLevels tbody tr").remove();
                        OLViewModel.BusinessLevelList(MappedBUModelList);
                        for (var i = 0, j = OLViewModel.BusinessLevelList().length; i < j; i++) {
                            GetFactorTabData(OLViewModel.BusinessLevelList()[i]);
                        }
                        ko.applyBindingsToNode($('#tblOrgLevels tbody .details-control'), { click: OLViewModel.trclick }, OLViewModel);
                        OLTableObj = $('#tblOrgLevels').DataTable({


                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "bSortable": false,

                                "sClass": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false

                            }, {
                                "aTargets": [2],
                                "bVisible": true,
                            },
                            {
                                "aTargets": [3],
                                "bVisible": true,
                            },
                            {
                                "aTargets": [4],
                                "bVisible": true,
                            },
                            {
                                "aTargets": [5],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": OLViewModel.ControlsAccess()
                            }]
                        });

                        $('#tblOrgLevels').DataTable().draw(false);

                    }
                    else {
                        OLViewModel.BusinessLevelList([]);
                        GetFactorTabData(OLViewModel.BusinessLevelList([]));
                        OLTableObj = $('#tblOrgLevels').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "sClass": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "bSortable": false

                            },
                            {
                                "aTargets": [2],
                                "bVisible": true,

                            },
                            {
                                "aTargets": [3],
                                "bVisible": true,
                            },
                            {
                                "aTargets": [4],
                                "bVisible": true,
                            },
                            {
                                "aTargets": [5],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": OLViewModel.ControlsAccess()
                            }]
                        });
                        $('#tblOrgLevels').DataTable().draw(false);

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            var msg = 'An error occurred.Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(OLViewModel), true);

                        }


                    }
                    //moving the trclick binding before datatable is being drawn 
                    //ko.applyBindingsToNode($('#tblOrgLevels tbody .details-control'), { click: OLViewModel.trclick }, OLViewModel);
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllBusinessLevels() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessLevels() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessLevels() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
        }


        //Adds the Table HTML
        function GetFactorTabData(data) {
            try {
                var HtmlBody = '<table id="tblOrgLevels" class="table table-bordered border-0 no-footer dataTable" cellspacing="0">'
                HtmlBody += '<thead>'
                HtmlBody += '<tr>'
                HtmlBody += '<th class="site_name"></th>'
                HtmlBody += '<th class="site_name d-none" >Organizational Level Id</th>'
                HtmlBody += '<th class="site_name">';
                HtmlBody += (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelName') == -1) ? 'Organizational Level Name' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevelName')].Name();
                HtmlBody += '</th>'
                HtmlBody += '<th class="site_name">';
                HtmlBody += (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName') == -1) ? 'Short Name' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName')].Name();
                HtmlBody += '</th>'
                HtmlBody += '<th class="site_name">';
                HtmlBody += (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description') == -1) ? 'Description' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Description')].Name();
                HtmlBody += '</th>'
                HtmlBody += '<th class="parent_action" style="text-align:center;">';
                HtmlBody += (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();
                HtmlBody += '</th>'
                HtmlBody += '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: BusinessLevelList">' +
                    '<tr>' +
                    '<td class="details-control action-bgcolor"><div style="display:none"></div></td>' +
                    '<td style="display:none" data-bind="text: BlId"></td>' +
                    '<td class="text-left" data-bind="text: BlName"></td>' +
                    '<td class="text-left" data-bind="text: BlShortName"></td>' +
                    '<td class="text-left" data-bind="text: BlDescription"></td>' +
                    '<td class="text-center action-bgcolor">' +
                    '<a href="javascript:void(0)" class="btn-borderless widget-button" data-bind="attr:{title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EditButton\') == -1) ? \'Edit\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'EditButton\')].Name },click:$root.editFunctionalityOL,css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" class="btn-borderless widget-button" data-bind="attr:{title: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'DeleteButton\') == -1) ? \'Delete\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'DeleteButton\')].Name },click: $root.deleteFunctionalityOL,css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>';
                document.getElementById('adddivtabbody').innerHTML = HtmlBody;
                ko.applyBindingsToNode($('#tblOrgLevels').find('tbody').get(0), { foreach: OLViewModel.BusinessLevelList }, OLViewModel);
                var selected = new BusinessLevelModel({ BlId: data.BlId(), BlName: data.BlName() });
                OLViewModel.SelectedBusinessLevelDetails(selected);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }


        //On click of details column
        function trclick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = OLTableObj.row($(event.currentTarget).closest('tr'));
                OLViewModel.currentTarget($(event.currentTarget).closest('tr').get(0)._DT_RowIndex);
                checkExpandedRow(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(format(row.data())).show();
                    tr.addClass('shown');
                    ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: OLViewModel.BusinessLevelValueList }, OLViewModel);
                    ko.applyBindingsToNode($('#addSubFactorBtn'), { disabled: true, click: OLViewModel.addBusinessLevelValueFunctionality }, OLViewModel);
                    RfSubFactorTableObj = $("#subfactor").DataTable({
                        "bInfo": true,
                        "bResponsive": true,
                        "bPaginate": true,

                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": false
                        }, {
                            "aTargets": [1],
                            "bSortable": true
                        },
                        {
                            "aTargets": [2],
                            "bSortable": true
                        },
                        {
                            "aTargets": [3],
                            "bSortable": false,
                            "sClass": "text-center",
                            "bVisible": OLViewModel.ControlsAccess()

                        }]
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: trclick() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#tblOrgLevels').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = OLTableObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    var tr = $('#tblOrgLevels').find('tr').get(i);
                    if (OLTableObj.row(tr).index() != row.index()) {
                        var tableRowIndex = (info.page * info.length) + (i - 1);

                        if ((OLTableObj.row(tableRowIndex).child() != undefined) && (OLTableObj.row(tableRowIndex).child.isShown())) {
                            OLTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown')
                            j = $('#tblOrgLevels').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function format(data) {
            try {
                var ID = data[1];
                OLViewModel.BlId(data[1]);
                OLViewModel.BusinessLevelValueList([]);
                for (var i = 0; i < OLViewModel.BusinessLevelList().length; i++) {
                    if (OLViewModel.BusinessLevelList()[i].BlId() == ID) {
                        if (OLViewModel.BusinessLevelList()[i].BusinessLevelValueList()[0].BlvalueName() != "NA" && OLViewModel.BusinessLevelList()[i].BusinessLevelValueList()[0].BlvalueId() != 999) {
                            OLViewModel.BusinessLevelValueList(OLViewModel.BusinessLevelList()[i].BusinessLevelValueList());

                            break;
                        }
                    }
                }
                var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                    '<div class="panel panel-success panel-margin">' +
                    '<div class="panel-heading">' +
                    '<h5 class="panel-title riskFactorCellPanel mt-2 mb-2 text-left">Organizational Sub Levels';
                if (OLViewModel.ControlsAccess()) {
                    SfHtml += '<button id="addSubFactorBtn" class="primary-btn pull-right" style="margin-top:-15px;" data-bind="click: $root.addBusinessLevelValueFunctionality" title="Click to add new entry">' +
                        '<i class="fa fa-plus"></i> Add Organizational Sub Levels' +
                        '</button>';
                }
                SfHtml += '</h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">' +
                    '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="display:none">Organizational Level Value ID</th>' +
                    '<th>Organizational Sub Level Name</th>' +
                    '<th>Short Name</th>' +
                    '<th class="actions" style="text-align:center;">Actions</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: BusinessLevelValueList">' +
                    '<tr>' +
                    '<td style="display:none" data-bind="text: BlvalueId"></td>' +
                    '<td class="text-left" data-bind="text: BlvalueName"></td>' +
                    '<td class="text-left" data-bind="text: BlvalueShortName"></td>' +
                    '<td class="text-center">' +
                    '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editOLValueFunctionality, css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteOLValueFunctionality, css:{"disabled": (!$root.appsecurity.finalConfigurationSave())}">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>';

                return SfHtml;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: format() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        /********************************************************FOR LEVEL VALUES********************************************************************************/

        //To add a Business Level Value
        function addBusinessLevelValueFunctionality(data, event) {
            try {
                var newBusinessLevelValue = new BuLevelValueListModel({ BlId: OLViewModel.BlId(), BlvalueId: 999, BlvalueName: "", BlvalueShortName: "" });
                OLViewModel.editableBusinessLevelValue(newBusinessLevelValue);
                OLViewModel.rsfPopUpTitle((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddSubOrgdetails') == -1) ? 'Add Organizational Sub Level Details' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddSubOrgdetails')].Name());
                ko.applyBindingsToNode($('#frmSubFactor').find('button').get(2), { click: OLViewModel.cancelRsfButton }, OLViewModel);
                OLViewModel.addPopUpCss(true);
                OLViewModel.editPopUpCss(false);
                $('#frmSubFactor').modal('show');
                $('#modalContentSubFactor').css({
                    'margin-top': '30%'
                })
                isRsfEdit = false;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addBusinessLevelValueFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function saveRsfButton(data) {
            $('#valErrorOLValue').hide();
            var duplicateCheck = 0;
            var duplicateShortCheck = 0;
            for (var i = 0, j = OLViewModel.BusinessLevelValueList().length; i < j; i++) {
                if ((data.BlvalueName().toUpperCase() == OLViewModel.BusinessLevelValueList()[i].BlvalueName().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheck++;
            }
            for (var i = 0, j = OLViewModel.BusinessLevelValueList().length; i < j; i++) {
                if ((data.BlvalueShortName().toUpperCase() == OLViewModel.BusinessLevelValueList()[i].BlvalueShortName().toUpperCase()) && (data.TargetRow() != i)) {
                    duplicateShortCheck++;
                }
            }
            if (data.BlvalueName() == "") {
                $('#valErrorOLValue').show();
                $('#valErrorOLValue').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelName') == -1) ? 'Organizational Sub Level name is required.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelName')].Name());
            }

            else if (data.BlvalueShortName() == "") {
                $('#valErrorOLValue').show();
                $('#valErrorOLValue').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelShrtName') == -1) ? 'Organizational Sub Level Short name is required.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSubLevelShrtName')].Name());
            }
            else if (data.BlvalueName().length > 300) {
                $('#valErrorOLValue').show();
                $('#valErrorOLValue').text((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelName100') == -1) ? 'Organizational Sub Level name cannot exceed 100 characters. Please enter a valid one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelName100')].Name());
            }
            else {
                if (!isRsfEdit) {
                    if (duplicateCheck == 1) {

                        $('#valErrorOLValue').show();
                        $('#valErrorOLValue').text('"' + data.BlvalueName() + '"' + ' ' + ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther') == -1) ? 'already exists. Please enter a different one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther')].Name()));
                    }
                    else if (duplicateShortCheck == 1) {

                        $('#valErrorOLValue').show();
                        $('#valErrorOLValue').text(data.BlvalueShortName() + ' ' + (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther') == -1) ? ' already exists. Please enter a different one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther')].Name());
                    }
                    else {
                        addBusinessLevelValue(data);
                        $('#frmSubFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
                else {
                    if (duplicateCheck == 1) {

                        $('#valErrorOLValue').show();
                        $('#valErrorOLValue').text(data.BlvalueName() + ' ' + (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther') == -1) ? 'already exists. Please enter a different one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther')].Name());
                    }
                    else if (duplicateShortCheck == 1) {

                        $('#valErrorOLValue').show();
                        $('#valErrorOLValue').text(data.BlvalueShortName() + ' ' + (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther') == -1) ? 'already exists. Please enter a different one.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyExitsEnterOther')].Name());
                    }
                    else {
                        updateBusinessLevelValue(data);
                        $('#frmSubFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }
        }

        function addBusinessLevelValue(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/addBusinessLevelValue",
                    headers: headers,
                    type: "POST",
                    data: { BlId: OLViewModel.BlId(), BlName: data.BlvalueName(), BlShortName: data.BlvalueShortName(), BlvalueId: data.BlvalueId() }

                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in addBusinessLevelValue() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult[0] != null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            return new BusinessLevelModel(result);
                        });
                        OLViewModel.BusinessLevelList(MappedBUModelList);
                        var ID = OLViewModel.BusinessLevelList()[0].BlId() - 1;
                        if (OLViewModel.BusinessLevelList()[0].Flag() == 1) {
                            GetAllBusinessLevels().then(function () {
                                $($('#tblOrgLevels tbody .details-control').get(OLViewModel.currentTarget())).trigger('click');
                                logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgAdded') == -1) ? 'Organizational Sub Level added successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgAdded')].Name(), 'Success', system.getModuleId(OLViewModel), true);
                            })

                        }
                        else if (jsonResult[0].Incident_Description.startsWith('INC')) {
                            logger.logError((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgLevelExits') == -1) ? jsonResult[0].Incident_Description + 'Failed to add Organizational Sub Level.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgLevelExits')].Name(), 'Error', system.getModuleId(OLViewModel), true);
                        }
                    }
                    else {
                        logger.logError((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FailedOrgsubLevel') == -1) ? 'Failed to add Organizational Sub Level.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FailedOrgsubLevel')].Name(), 'Error', system.getModuleId(OLViewModel), true);
                    };
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addBusinessLevelValue() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in addBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
        }

        function cancelRsfButton(data) { }


        //Edit a Business Level Value
        function editOLValueFunctionality(data, event) {
            try {
                for (var i = 0, j = OLViewModel.BusinessLevelValueList().length; i < j; i++) {
                    if (data.BlvalueId() == OLViewModel.BusinessLevelValueList()[i].BlvalueId())
                        data.TargetRow(i);
                }
                var newBusinessLevelValue = new BuLevelValueListModel({
                    BlId: OLViewModel.BlId(), BlvalueId: data.BlvalueId(), BlvalueName: data.BlvalueName(),
                    BlvalueShortName: data.BlvalueShortName()
                });
                newBusinessLevelValue.TargetRow(data.TargetRow());
                OLViewModel.editableBusinessLevelValue(newBusinessLevelValue);
                OLViewModel.rsfPopUpTitle((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOrgSubLeveldetails') == -1) ? 'Edit Organizational Sub Level Details' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOrgSubLeveldetails')].Name());
                ko.applyBindingsToNode($('#frmSubFactor').find('input').get(0), { value: OLViewModel.editableBusinessLevelValue().BlvalueName }, OLViewModel);

                OLViewModel.addPopUpCss(false);
                OLViewModel.editPopUpCss(true);
                $('#frmSubFactor').modal('show');
                $('#modalContentSubFactor').css({
                    'margin-top': '30%'
                })
                isRsfEdit = true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in editOLValueFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function updateBusinessLevelValue(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/updateBusinessLevelValue",
                    headers: headers,
                    type: "POST",
                    data: { BlId: OLViewModel.BlId(), BlName: data.BlvalueName(), BlShortName: data.BlvalueShortName(), BlvalueId: data.BlvalueId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in updateOrganizationalLevel() method in OrganizationalLevel.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            return new BusinessLevelModel(result);
                        });
                        OLViewModel.BusinessLevelList(MappedBUModelList);
                        var ID = OLViewModel.BusinessLevelList()[0].BlId() - 1;
                        if (OLViewModel.BusinessLevelList()[0].Flag() == 1) {
                            GetAllBusinessLevels().then(function () {
                                $($('#tblOrgLevels tbody .details-control').get(OLViewModel.currentTarget())).trigger('click');
                                logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSubLevelUpdated') == -1) ? 'Organizational Sub Level updated successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSubLevelUpdated')].Name(), 'Success', system.getModuleId(OLViewModel), true);
                            })

                        }

                        else if (jsonResult[0].Incident_Description.startsWith('INC')) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLViewModel), true);
                        }

                        else
                            logger.logWarning((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchSubOrgExists') == -1) ? 'No such Organizational Sub Level exists. Please refresh the page and perform the edit operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchSubOrgExists')].Name(), 'Warning', system.getModuleId(OLViewModel), true);
                    }
                    else {
                        logger.logError((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(OLViewModel), true);

                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateOrganizationalLevel() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            };
        }

        //Delete a Business level value
        function deleteOLValueFunctionality(data, event) {
            try {
                var ID = event.currentTarget.id;
                var selectedRow = $(event.currentTarget).closest("tr").get(0);
                data.TargetRow(selectedRow._DT_RowIndex);
                app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousureSubOrgDelete') == -1) ? 'Are you sure you want to delete this Organizational Sub Level? Once deleted, it cannot be undone.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousureSubOrgDelete')].Name(), (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            deleteBusinessLevelValue(data, event);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteOLValueFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }
        function GetLowestOrganizationalName() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetLowestOrganizationalName",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call GetLowestOrganizationalName() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (result.length > 0 && result[0].Incident_Description == null) {
                        var MappedBUModelList = $.map(result, function (result) {
                            return new OrganizationallevellowestModel(result);
                        });
                        var MappedBUModelListDup = $.map(result, function (result) {
                            return new OrganizationallevellowestModel(result);
                        });
                        OLViewModel.LowestLevelName(MappedBUModelList[0].BlName());
                        OLViewModel.LowestLevelNameDup(MappedBUModelListDup);
                        $("#header-organization-level").text(result[0].BlName);
                    }

                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetLowestOrganizationalName() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
        }
        function deleteBusinessLevelValue(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/deleteBusinessLevelValue",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        BuLId: data.BlvalueId()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call deleteBusinessLevelValue() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {

                    if (result == 1) {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        OLTableObj.row(targetRow).remove().draw(false);

                        OLViewModel.BusinessLevelValueList.splice(data.TargetRow(), 1);
                        GetAllBusinessLevels();
                        logger.logSuccess((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelDeleted') == -1) ? 'Organizational Sub Level deleted successfully.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgSublevelDeleted')].Name(), 'Success', system.getModuleId(OLViewModel), true);

                    }
                    else if (result == 0) {
                        logger.logWarning((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchSubOrgExists') == -1) ? 'No such Organizational Sub Level exists.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoSuchSubOrgExists')].Name(), 'Warning', system.getModuleId(OLViewModel), true);
                    }
                    else if (result == 2) {
                        logger.logWarning((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgDependencies') == -1) ? 'The Organizational Sub Level that you are trying to delete has dependencies. Please contact the Administrator.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubOrgDependencies')].Name(), 'Success', system.getModuleId(OLViewModel), true)
                    }
                    else {
                        logger.logError(result + ' - ' + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status === 401) {
                        app.showMessage((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!OLViewModel.LocaleCheckFlag() || OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : OLViewModel.ObjGeneralSettings.LocalizedTextList()[OLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteBusinessLevelValue() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }
        }

        /*********************************************************Models definitions starts here******************************************************************/
        function OrganizationallevellowestModel(item) {
            try {
                var self = this;
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrganizationallevellowestModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }
        function OrganizationallevellowestDupModel(item) {
            try {
                var self = this;
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrganizationallevellowestModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }
        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.BlId = ko.observable($('<div/>').html(item.BlId).text());
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlDescription = ko.observable($('<div/>').html(item.BlDescription).text());
                self.BlShortName = ko.observable($('<div/>').html(item.BlShortName).text());
                self.Flag = ko.observable(item.Flag);
                self.TargetRow = ko.observable();
                if (item.BuLevelValueList != undefined) {
                    var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                        return new BuLevelValueListModel(result);
                    });
                    self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }
    });






